// Tokens stay in browser storage and never enter analytics events.
let widget: any = null
let pending: ((token: string) => void) | null = null
let loader: Promise<void> | null = null
const api = () => (window as any).turnstile
let runtimeSiteKey = ''
// Start on page load. Configuration failure leaves the build-time fallback available.
const configReady: Promise<void> = typeof window !== 'undefined' && typeof fetch === 'function' ? (() => {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 800)
  return fetch((process.env.VUE_APP_API_BASE_URL || '').replace(/\/$/, '') + '/api/intro/config', { signal: controller.signal })
    .then(response => response.ok ? response.json() : {}).then((config: { turnstileSiteKey?: string }) => { runtimeSiteKey = config.turnstileSiteKey || ''; clearTimeout(timeout) })
    .catch(() => { clearTimeout(timeout) })
})() : Promise.resolve()

export function clearGuest() {
  for (const key of ['TMP_USER_EMAIL', 'TMP_USER_ID', 'TMP_USER_CREATED_AT']) localStorage.removeItem(key)
}
export async function browserToken(onChecking: () => void, siteKey?: string): Promise<string> {
  if (siteKey === undefined) { await configReady; siteKey = runtimeSiteKey || process.env.VUE_APP_TURNSTILE_SITE_KEY }
  if (!siteKey) return ''
  onChecking()
  return new Promise(resolve => {
    let settled = false
    const finish = (token: string) => { if (!settled) { settled = true; clearTimeout(timer); pending = null; resolve(token) } }
    const timer = setTimeout(() => finish(''), 5000)
    if (!loader) loader = new Promise<void>((ready, reject) => {
      if (api()) { ready(); return }
      const script = document.createElement('script')
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
      script.async = true; script.onload = () => ready(); script.onerror = () => { loader = null; reject(new Error('unavailable')) }
      document.head.appendChild(script)
    })
    loader.then(() => {
      if (settled) return
      if (widget === null) {
        const host = document.createElement('div'); host.setAttribute('aria-label', 'Browser verification'); document.body.appendChild(host)
        widget = api().render(host, { sitekey: siteKey, execution: 'execute', 'refresh-expired': 'auto',
          callback: (token: string) => { if (pending) pending(token) },
          'expired-callback': () => api().reset(widget),
          'error-callback': () => { api().reset(widget); if (pending) pending('') }
        })
      } else api().reset(widget)
      pending = finish
      api().execute(widget)
    }).catch(() => finish(''))
  })
}
export async function guestSession(authApi: any, options: any = {}, onChecking = () => { /* Optional progress callback. */ }, track = '0', reuse = true): Promise<any> {
  const email = localStorage.getItem('TMP_USER_EMAIL')
  const id = localStorage.getItem('TMP_USER_ID')
  const created = Number(localStorage.getItem('TMP_USER_CREATED_AT'))
  if (reuse && email && id && created > 0 && Date.now() - created >= 0 && Date.now() - created < 86400000) {
    return { data: { isSuccess: true, data: { id, accessToken: email } } }
  }
  const turnstileToken = track === '0' ? await browserToken(onChecking) : ''
  const response = await authApi.createTmpUser({ ...options, params: { ...options.params, productTrackId: track, turnstileToken } })
  const guest = response.data?.data
  if (response.data?.isSuccess === false || !guest?.id || !guest?.accessToken) throw new Error('Visitor session unavailable')
  localStorage.setItem('TMP_USER_EMAIL', guest.accessToken)
  if (reuse) { localStorage.setItem('TMP_USER_ID', guest.id); localStorage.setItem('TMP_USER_CREATED_AT', String(Date.now())) }
  return response
}
export function costGuardCode(error: any): string {
  const code = error?.response?.data?.error?.apiErrorCode || error?.response?.data?.error_code
  return ['GUEST_LIMIT', 'SEARCH_LIMIT', 'DAILY_BUDGET_EXCEEDED'].includes(code) ? code : ''
}
